import { useEffect, useState } from 'react';
import { navTabs } from '@/mocks/home';

const stripTicker = '今日新补录 6 条 · 历史存档仍在持续整理';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 32);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div className="bg-primary-950 text-background-100">
        <div className="mx-auto flex h-9 max-w-shell items-center justify-between gap-4 px-4 md:px-6">
          <div className="flex min-w-0 items-center gap-2">
            <span className="flex h-4 w-4 shrink-0 items-center justify-center text-accent-400">
              <i className="ri-megaphone-line text-sm"></i>
            </span>
            <span className="truncate text-xs tracking-wide">{stripTicker}</span>
          </div>
          <div className="hidden items-center gap-4 text-xs text-background-300 md:flex">
            <span>2026 年 09 月 12 日 星期六</span>
            <span className="h-3 w-px bg-background-50/20"></span>
            <span>存档总条数 9,642</span>
          </div>
        </div>
      </div>

      <div
        className={`border-b transition-all duration-300 ${
          scrolled
            ? 'border-background-200 bg-background-50/95 backdrop-blur-md'
            : 'border-transparent bg-background-50/70 backdrop-blur-sm'
        }`}
      >
        <div className="mx-auto flex h-16 max-w-shell items-center gap-4 px-4 md:px-6">
          <a href="#top" className="flex shrink-0 cursor-pointer items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-archive-2-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                黑料社网
              </span>
              <span className="mt-1 text-[10px] tracking-[0.22em] text-foreground-500">
                HISTORY ARCHIVE
              </span>
            </span>
          </a>

          <nav className="ml-6 hidden items-center gap-1 lg:flex">
            {navTabs.map((tab) => (
              <a
                key={tab.id}
                href={`#${tab.id}`}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {tab.label}
              </a>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2">
            <div className="hidden items-center overflow-hidden rounded-md border border-background-300 bg-background-50 md:flex">
              <input
                type="text"
                aria-label="搜索往期存档"
                placeholder="搜关键词，翻旧账"
                className="h-9 w-40 bg-transparent px-3 font-label text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none xl:w-52"
              />
              <button
                type="button"
                aria-label="搜索"
                className="flex h-9 w-9 cursor-pointer items-center justify-center bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-search-line text-base"></i>
              </button>
            </div>

            <a
              href="#archive"
              className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-foreground-800 sm:flex"
            >
              <i className="ri-time-line text-base"></i>
              往期回顾
            </a>

            <button
              type="button"
              aria-label="打开导航菜单"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
            >
              <i className={menuOpen ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
            <nav className="grid grid-cols-2 gap-2">
              {navTabs.map((tab) => (
                <a
                  key={tab.id}
                  href={`#${tab.id}`}
                  onClick={() => setMenuOpen(false)}
                  className="cursor-pointer whitespace-nowrap rounded-md bg-background-100 px-3 py-2.5 text-center font-label text-sm text-foreground-800 transition-colors hover:text-primary-700"
                >
                  {tab.label}
                </a>
              ))}
            </nav>
            <div className="mt-3 flex items-center overflow-hidden rounded-md border border-background-300 bg-background-50">
              <input
                type="text"
                aria-label="搜索往期存档"
                placeholder="搜关键词，翻旧账"
                className="h-10 flex-1 bg-transparent px-3 font-label text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
              />
              <button
                type="button"
                aria-label="搜索"
                className="flex h-10 w-10 cursor-pointer items-center justify-center bg-primary-500 text-background-50"
              >
                <i className="ri-search-line text-base"></i>
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}